import { useLazyGetDynamicElementsQuery } from '@hts/shared/api';
import { ENotAuthNavigation, EPageDynamicElementType } from '@hts/shared/enums';
import { IPageDepartmentSectionEntry } from '@hts/shared/types';
import { useCallback, useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const useGetPageDepartment = () => {
  const { page: pageParam } = useParams();
  const { pathname, search } = useLocation();

  const [getDynamicElementsRequest, dynamicElementsState] = useLazyGetDynamicElementsQuery();

  const isHome = pathname === ENotAuthNavigation.MAIN;
  const isPages = pathname.includes(ENotAuthNavigation.PAGES);

  const requestParams = useMemo(() => {
    if (isHome) {
      return { link: ENotAuthNavigation.MAIN, useCache: true };
    }

    if (isPages) {
      const queryParams = new URLSearchParams(search);
      const token = queryParams.get('token') || undefined;

      return { link: `${ENotAuthNavigation.PAGES}/${pageParam}`, token, useCache: false };
    }

    return { link: ENotAuthNavigation.MAIN, useCache: true };
  }, [isHome, isPages, pageParam, search]);

  const fetchData = useCallback(() => {
    const { useCache, ...params } = requestParams;

    getDynamicElementsRequest(params, useCache);
  }, [requestParams, getDynamicElementsRequest]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const pageDepartment = useMemo<IPageDepartmentSectionEntry | null>(() => {
    const dynamicElements = dynamicElementsState.data?.dynamicElements || [];

    if (!dynamicElements.length) return null;

    const result = dynamicElements.find(
      ({ type }) => type === EPageDynamicElementType.PAGE_DEPARTMENT_SECTION
    );

    return result as IPageDepartmentSectionEntry;
  }, [dynamicElementsState?.data]);

  return { pageDepartment, dynamicElementsState };
};
